import { ApplicationResolution, ApplicationStatus } from "model/Application";

export interface ApplicationStatusUpdate {
  readonly resolution: ApplicationResolution;
  readonly status: ApplicationStatus.CLOSED;
}

export function toApplicationStatusUpdate(
  requestedStatus: ApplicationStatus.OFFERED | ApplicationStatus.CLOSED,
): ApplicationStatusUpdate {
  return requestedStatus === ApplicationStatus.OFFERED
    ? {
        resolution: ApplicationResolution.ACCEPTED,
        status: ApplicationStatus.CLOSED,
      }
    : {
        resolution: ApplicationResolution.REJECTED,
        status: ApplicationStatus.CLOSED,
      };
}
